module.exports = function(app) {
	app.filter('dateInput', function() {
		return function(dateInput, defaultToToday) {

			if (!dateInput) {
				return defaultToToday
					? new Date()
					: '';
			}
			if (dateInput instanceof Date) {
				return dateInput;
			}
			if (dateInput.length === 10 && dateInput.indexOf('/') === 4) {
				var d = dateInput.split('/');
				return new Date (d[0], d[1] - 1, d[2]);
			}
			if (dateInput.length === 10 && dateInput.indexOf('/') === 2) {
				var d = dateInput.split('/');
				return new Date(d[2], d[0] - 1, d[1]);
			}
			if (dateInput.length === 10 && dateInput.indexOf('-') === 4) {
				var d = dateInput.split('-');
				return new Date(d[0], d[1] - 1, d[2]);
			}

			return dateInput;
		}
	});
};
